import React from 'react';

import useFormatLastActive from '../../utils/useFormatLastActivity';
import * as Styled from './styled';

function ChatLastActivity() {
	const lastActivity = useFormatLastActive();

	if (!lastActivity) return null;

	return <Styled.SubTitle>Seen {lastActivity}</Styled.SubTitle>;
}

export default ChatLastActivity;
